import { configureStore } from '@reduxjs/toolkit';
import userEntitlementReducer from './slices/userEntitlementSlice';

export const store = configureStore({
  reducer: {
    userEntitlement: userEntitlementReducer,
  },
});

